import { useLocale } from "@/hooks/useLocale";
import { Banner } from "@/ui/Banner";
import { Col, Row } from "react-bootstrap";
import { DynamicText } from "@/ui/DynamicText";
import { DynamicHtml } from "@/ui/DynamicHtml";

export const TeamPageBannerSection = ({ className }) => {
  const locale = useLocale();

  return (
    <Banner
      className={className}
      title={<DynamicText path={`page.team.banner.title.${locale}`} tag="h1" />}
      image={{ path: "page.team.banner.image", src: "/assets/banners/default.webp" }}
    >
      <Row>
        <Col xs={12} md={6}>
          <DynamicHtml path={`page.team.banner.text.${locale}`} />
        </Col>
      </Row>
    </Banner>
  );
};
